module.exports = __webpack_public_path__ + "img/ventas.551e8a94.jpeg";